const keys = {
	commissionDistribution: (contractId: string) =>
		["commissionDistribution", contractId] as const,
};

export default keys;
